export const environment = {
  production: false,
  loginURL: 'oauth2/authorization/azure',
  baseApiUrl: 'services/minossebe/api'
};

